import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useApi } from "../../../../hooks/useApi";
import LineBox from "../../../DefaultStyles/LineBox";
import {
  GetAllNoHideSubsnameList,
  GetIsActivatedSubsId,
  GetSubscriptionSetData,
} from "../../../../Api/ServiceDatas";
import ReactApexChart from "react-apexcharts";
import { ISeries } from "../PayBoard/PayHistorySection";
import { getThousandComma } from "../../../../Api/ApiCommon";
import {
  DashBoardSectionTitle,
  DashBoardSectionTitleContainer,
  DashBoardViewDate,
  IndateSectionProps,
} from "../UserBoard/IndateSection";
import useIsMobile from "../../../../hooks/useIsMobile";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import { DropDownLabel } from "./CreateSection";
import { GetAllNoHideSubsnameListv3 } from "../../../../ApiTS/ServiceDatasTS_V3";
import { getSubsNameBySubsId3 } from "../../../../AdminApi/3.0_utils";

interface StatusSectionProps extends IndateSectionProps {}

export default function StatusSection({ filter }: StatusSectionProps) {
  const isMobile = useIsMobile();

  const [detailList, setDetailList] = useState("");
  const [series, setSeries] = useState<ISeries[]>([
    {
      name: "",
      data: [0, 0, 0, 0],
    },
  ]);
  const [subsList, setSubsList] = useState<string[]>([]);
  const [subsDropdownValue, setSubsDropdownValue] = useState<OptionType[]>([]);

  const { response } = useApi({
    method: "get",
    url:
      filter.startDate !== "" && filter.endDate !== ""
        ? `dash/percent?type=party&subtype=status&date=${dayjs(filter.endDate)
            .add(1, "day")
            ?.format("YYYY-MM-DD")}` +
          (detailList?.length === 0 || detailList?.includes('"0"')
            ? ""
            : `&detail=${detailList}`)
        : undefined,
  });

  // subscription 선택 옵션
  const subsOptionList = isMobile ? [] : [{ value: "0", label: "전체" }];

  const subsNameList = GetAllNoHideSubsnameListv3();

  for (let i = 0; i < subsNameList.length; i++) {
    const e = subsNameList[i];

    subsOptionList.push({ value: e?.split("_")[0], label: e });
  }

  useEffect(() => {
    let subsList: string[] = [];
    let normalData: number[] = [];
    let exitedData: number[] = [];
    let endedData: number[] = [];
    let scheduledData: number[] = [];

    if (response?.status === 200) {
      for (let i = 0; i < response?.data.length; i++) {
        const element = response?.data[i];

        if (Number(element?.detail)) {
          const subsId = Number(element.detail);

          normalData.push(element?.data?.normal ?? 0);
          exitedData.push(element?.data?.exited ?? 0);
          endedData.push(element?.data?.ended ?? 0);
          scheduledData.push(element?.data?.scheduled ?? 0);

          subsList.push(`${subsId}_${getSubsNameBySubsId3(subsId)}`);
        }
      }

      setSeries([
        {
          name: "진행중",
          data: normalData,
        },
        {
          name: "예정",
          data: scheduledData,
        },
        {
          name: "종료",
          data: endedData,
        },
        {
          name: "해산",
          data: exitedData,
        },
      ]);

      setSubsList(subsList);
    }
  }, [response]);

  useEffect(() => {
    const arr: string[] = [];
    const keyArr: string[] = [];

    console.log(subsDropdownValue);

    for (let i = 0; i < subsDropdownValue.length; i++) {
      const element = subsDropdownValue[i];

      if (element.value === "0") {
        setSubsDropdownValue([]);
      }

      arr.push(`"${element?.value}"`);
      keyArr.push(`${element?.value}`);
    }

    setDetailList(arr.toString());
  }, [subsDropdownValue]);

  return (
    <>
      <DashBoardSectionTitleContainer>
        <DashBoardSectionTitle>파티 상태 현황</DashBoardSectionTitle>

        <DropDown
          isDisabled={false}
          initText="전체"
          optionList={subsOptionList}
          dropdownMultiValue={subsDropdownValue}
          setDropDownMultiValue={setSubsDropdownValue}
          isMulti={true}
          initValue={"0"}
        />
      </DashBoardSectionTitleContainer>

      <LineBox boxPadding={"28px 32px"}>
        <DropDownLabel>
          {detailList?.split(",")?.map((d) => {
            const subsId = d?.replaceAll('"', "");

            if (d !== "") {
              return `${getSubsNameBySubsId3(Number(subsId))}${
                detailList?.split(",")[detailList?.split(",")?.length - 1] !==
                  d && detailList?.split(",")?.length > 1
                  ? ", "
                  : ""
              }`;
            }
          })}
        </DropDownLabel>
        <DashBoardViewDate isMobile={isMobile}>
          {filter.endDate} 기준
        </DashBoardViewDate>

        <div
          style={{
            width: "100%",
            height: 800,
          }}
        >
          <ReactApexChart
            type="bar"
            height={800}
            series={series}
            options={{
              chart: {
                type: "bar",
                height: 350,
                stacked: true,
                stackType: "100%",
                toolbar: {
                  show: false,
                },
                zoom: {
                  enabled: false,
                },
              },
              grid: {
                xaxis: {
                  lines: {
                    show: true,
                  },
                },
                yaxis: {
                  lines: {
                    show: false,
                  },
                },
              },
              plotOptions: {
                bar: {
                  horizontal: true,
                  dataLabels: {
                    hideOverflowingLabels: true,
                  },
                  borderRadius: 10,
                  barHeight: "70%",
                },
              },
              dataLabels: {
                formatter: (val) => {
                  if (Math.round(Number(val) * 10) / 10 > 3)
                    return `${Math.round(Number(val) * 10) / 10}%`;
                  return "";
                },
              },
              stroke: {
                width: 1,
                colors: ["#fff"],
              },
              xaxis: {
                categories: subsList,
              },
              tooltip: {
                y: {
                  formatter: (val) => {
                    return getThousandComma(val) + "개";
                  },
                },
              },
              fill: {
                opacity: 1,
              },
              legend: {
                position: "top",
                horizontalAlign: "center",
                offsetX: 40,
                fontFamily:
                  "-apple-system, BlinkMacSystemFont, 'Apple SD Gothic Neo', Pretendard Variable, Roboto, 'Noto Sans KR', 'Segoe UI', 'Malgun Gothic', sans-serif",
                markers: {
                  width: 10,
                  height: 10,
                  offsetX: -4,
                  radius: 10,
                },
                fontSize: "13px",
                fontWeight: 500,
                itemMargin: {
                  horizontal: 16,
                },
              },
            }}
          />
        </div>
      </LineBox>
    </>
  );
}
